import React from "react";
import PropTypes from "prop-types";
import { Card, Button, message, Icon, Input, Table, Select, Modal,Form, Drawer, Spin, Switch } from "antd";
import { List } from "immutable";
// import { DocumentViewer } from "../../components";
import { CaseService } from "services";
import CaseLeegalityService from "services/case-leegality-agreement-service"; 
import moment from "moment";
import { AGREEMENT_APPLICANT_DETAILS_COLS, AGREEMENT_LOGS_COLS } from "../../constants/table-columns";
import { LeegalityTemplateDrawer } from "../../modules/leegality/leegality-home";
// import axios from "axios";


const { Option } = Select;


// const {form} = Form;

// import { INPUT_TYPES, NATURE_OF_ASSOCIATION_TYPES
// } from "constants/index";
// import { OrderedMap } from "immutable";
// import CompanyService from "services/company-service";
// import _capitalize from "lodash/capitalize";

// const styles = {
//     agreementDetailKeys: { 
//         fontWeight: "700", 
//         width:"50%", 
//         background: "rgba(138, 138, 138, 0.1)" 
//     },
//     agreementDetailKeysRequired: { 
//         fontWeight: "700", 
//         width:"50%", 
//         background: "rgba(138, 138, 138, 0.1)",
//         color: "#FF808B"
//     },
//     agreementDetailValues: {
//         width:"45%",
//         marginLeft: "5%",
//         whiteSpace: "nowrap",
//         overflow: "hidden",
//         textOverflow: "ellipsis",
//         display: "flex",
//         alignItems: "center",
//         // whiteSpace: "pre-line"
//     }
// };



class Agreement extends React.Component {
    state = {
        data: new List([]),
        html: "",
        pdf: null,
        loading: true,
        status: null,
        error: "",
        is_eligible: 1,
        is_audit_trail: 0,
        audit_trail: "",
        is_initiate_active: false,
        is_signed_document: false,
        signed_document: "",
        urls: [],
        isUrlsModalVisibile: false,
        openRetriggerModal: false,
        doc: 1,
        adhocAmount: "",
        language: "",
        witness: "",
        agreementApplicantData: [],
        last_updated: "",
        total_associate: "",
        logs_data: [],
        languageList: [],
        witnessList: [],
        modalVisible : false,
        formFields: [{name:"",occupation:"",relationship:"",address:"",state:"",city:"",pincode:"",phone:""},{name:"",occupation:"",relationship:"",address:"",state:"",city:"",pincode:"",phone:""}],
        userLegailityDropdown:[],
        employeeId:"",
        finnOneId: "",
        referenceResponse:false,
        createReferenceData: [],
        isVisible: false,
        templateData: {},
        legality_data : {},
        loading : false,
        isManualSigned: {},
        previewPdfModalVisible: false,
        previewPdfLoading: false,
        previewPdfResult: null,
        previewPdfSelectedPage: 1,
        previewPdfSelectedKey: null,
        previewPdfBlobUrl: null,
        previewPdfRemarks: {},
        previewPdfRemarkSaving: false,
        deleteModalVisible: false,
        deleteRemarks: "",
        deleting: false,
        retriggerModalVisible: false,
        retriggerRemarks: ""
    }

    retriggerReason = null;

    componentDidMount() {
        this.getAgreementData(this.props.caseId, this.state.doc, 0);
        this.UserLegalityDropdown();
        this.getCreateReferenceData(this.props.caseId);
    }
    
    getCreateReferenceData = (caseId) => {
        try {
            CaseLeegalityService.getCreateReferenceData(caseId).then(({data}) => {
                this.setState({createReferenceData: [...(data?.legality_relationship || [])], referenceResponse:true});
            }).catch(() => {
                message.error("Error in getting data");
            });
        }catch (e) {
            message.error("Error in getting data");
        }
    }

    getAgreementData = (caseId, docId, refresh) => {
        this.setState({ loading: true, error: null })

        CaseLeegalityService.getCaseAgreementData(caseId, docId, refresh ,this.state.legality_data.document_id).then((data) => {
            const applicants = data?.data?.data?.applicants_details;
            const manualSignedState = {};
            applicants?.forEach(applicant => {
                manualSignedState[applicant.id] = applicant?.is_manual_signed;
            });
            this.setState({
                legality_data: data.data.data,
                agreementApplicantData: data.data.data.applicants_details,
                isManualSigned: manualSignedState,
                last_updated: data.data.data.last_updated,
                status: data.data.data.status,
                total_associate: data.data.data.total_associate,
                logs_data: data.data.data.logs,
                signed_document: data.data.data.signed_document,
                languageList: data.data.data.document_type_detail.language,
                witnessList: data.data.data.document_type_detail.witeness
            });
        })
        .catch((error) => {
            console.error("Error is ", error);
            this.setState({ error: error.message });
          })         
          .finally(() => {
            this.setState({ loading: false });
          });
    }

    openDeleteModal = () => {
        this.setState({ deleteModalVisible: true, deleteRemarks: "" });
    }

    closeDeleteModal = () => {
        this.setState({ deleteModalVisible: false, deleteRemarks: "" });
    }

    deleteRequest = () => {
        const remarks = (this.state.deleteRemarks || "").trim();
        if (!remarks) {
            message.error("Please enter a reason for deleting");
            return;
        }
        try {
            this.setState({ deleting: true });
            message.loading("Deleting request please wait...");
            /* eslint-disable */
           CaseLeegalityService.deleteAgreementRequest(this.props.caseId, this.state.doc, this.state.legality_data.document_id, remarks).then(()=> {
                message.success("Agreement request deleted");
                this.setState({ deleteModalVisible: false, deleteRemarks: "", deleting: false });
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           }).catch(() => {
                message.error("Error in deleting request");
                this.setState({ deleting: false });
           });
        } catch (e) {
            message.error("Error in deleting request");
            this.setState({ deleting: false });
        }
    }

    manuallySigned = () => {
        try {
            message.loading("signing  request please wait...");
            /* eslint-disable */
           CaseLeegalityService.manuallySingedRequest(this.props.caseId, this.state.doc, this.state.legality_data.document_id).then(()=> {
                message.success("Manually signed");
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           });
        } catch (e) {
            message.error("Error in signed request");
        }
    }

    UserLegalityDropdown=()=>{
        CaseLeegalityService.getUserLegalityDropdown().then((response)=>{
            this.setState({userLegailityDropdown: response.data})

        })
    }
    
    createReference = () =>  {
            this.props.form.validateFields((err, fieldsValue) => {
                if (!err) {    
                                try{
                                    let firstFormData, secondFormData;
                                    let getFormLength =Object.keys(fieldsValue).length;
                                    if(getFormLength){
                                        firstFormData = Object.keys(fieldsValue).filter(el=>el.slice(-1) == 1).reduce((accumulator, currentValue) => {
                                            accumulator[currentValue.slice(0, -1)] = fieldsValue[currentValue];
                                            return accumulator;
                                        }, {});
                                        secondFormData = Object.keys(fieldsValue).filter(el=>el.slice(-1) == 2).reduce((accumulator, currentValue) => {
                                            accumulator[currentValue.slice(0, -1)] = fieldsValue[currentValue];
                                            return accumulator;
                                        }, {});
                                    }
                                    let finalDataToSend = getFormLength ? [firstFormData, secondFormData] : this.state.formFields;
                                message.loading("Creating Reference please wait...");      
                                CaseLeegalityService.createReference(this.props.caseId, finalDataToSend).then((res)=> {
                                message.success("Refrence details created successfully");
                                if(res.data){
                                    this.getCreateReferenceData(this.props.caseId);
                                    this.setState({referenceResponse:true, modalVisible:false})
                                }
                               })
                               .catch(function (error) {
                                console.log(error);
                              });
                             }
                                catch (e){
                                message.error("Error in Create Reference")
                                console.log("inside err", e)
                             }}
              })  
        }
    
    
    sendEmails = () => {
        try {
            message.loading("Sending email please wait...");
            /* eslint-disable */
           CaseLeegalityService.sendEmailDetails(this.props.caseId, this.state.doc).then(()=> {
                message.success("Email sent successfully");
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           });
        } catch (e) {
            message.error("Error in sending email");
        }
    }

    refresh = () => {
        this.getAgreementData(this.props.caseId, this.state.doc, 1);
    }

    previewPdf = () => {
        this.revokePreviewBlob();
        this.setState({ previewPdfModalVisible: true, previewPdfLoading: true, previewPdfResult: null, previewPdfBlobUrl: null });
        CaseLeegalityService.previewPdfValidation(this.props.caseId)
            .then((res) => {
                const data = res.data || {};
                const rows = data.results || [];
                // Auto-focus the first flagged (mismatch, else not-in-pdf) row.
                const firstFlag = rows.find(r => r.status === "mismatch")
                    || rows.find(r => r.status === "not_found_in_pdf")
                    || rows[0];
                // Pre-fill the per-parameter remark boxes from any saved remarks.
                const remarks = {};
                rows.forEach(r => { if (r.key && r.remark) { remarks[r.key] = r.remark; } });
                this.setState({
                    previewPdfResult: data,
                    previewPdfLoading: false,
                    previewPdfSelectedKey: firstFlag ? firstFlag.key : null,
                    previewPdfSelectedPage: (firstFlag && firstFlag.pdf_page) ? firstFlag.pdf_page : 1,
                    previewPdfRemarks: remarks,
                    previewPdfRemarkSaving: false
                });
                // Fetch the annotated PDF (mismatches boxed in red) for the viewer.
                if (data.applicable && data.pdf_url) {
                    CaseLeegalityService.previewPdfAnnotated(this.props.caseId)
                        .then((blobRes) => {
                            const url = window.URL.createObjectURL(blobRes.data);
                            this.setState({ previewPdfBlobUrl: url });
                        })
                        .catch(() => { /* fall back to plain pdf_url in the iframe */ });
                }
            })
            .catch((e) => {
                const msg = (e && e.response && e.response.data && e.response.data.error) || "Failed to validate the PDF";
                message.error(msg);
                this.setState({ previewPdfLoading: false, previewPdfModalVisible: false });
            });
    }

    revokePreviewBlob = () => {
        if (this.state.previewPdfBlobUrl) {
            try { window.URL.revokeObjectURL(this.state.previewPdfBlobUrl); } catch (e) { /* noop */ }
        }
    }

    closePreviewPdf = () => {
        this.revokePreviewBlob();
        this.setState({ previewPdfModalVisible: false, previewPdfBlobUrl: null });
    }

    selectPreviewRow = (row) => {
        this.setState({
            previewPdfSelectedKey: row.key,
            previewPdfSelectedPage: row.pdf_page || this.state.previewPdfSelectedPage
        });
    }

    onPreviewRemarkChange = (key, value) => {
        this.setState({
            previewPdfRemarks: { ...this.state.previewPdfRemarks, [key]: value }
        });
    }

    saveAllPreviewRemarks = () => {
        const R = this.state.previewPdfResult || {};
        const remarks = this.state.previewPdfRemarks || {};
        // Collect every unmatched row that has a non-empty remark filled in.
        const payload = (R.results || [])
            .filter(r => r.status !== "ok")
            .filter(r => (remarks[r.key] || "").trim())
            .map(r => ({
                key: r.key,
                parameter: r.parameter,
                section: r.section,
                status: r.status,
                pdf_value: r.pdf_value,
                backend_value: r.backend_value,
                remark: (remarks[r.key] || "").trim(),
            }));
        if (!payload.length) {
            message.warning("Please enter at least one remark before saving.");
            return;
        }
        this.setState({ previewPdfRemarkSaving: true });
        CaseLeegalityService.savePreviewRemarks(this.props.caseId, payload)
            .then(() => {
                message.success(`Saved ${payload.length} remark(s).`);
                this.setState({ previewPdfRemarkSaving: false });
            })
            .catch((e) => {
                const msg = (e && e.response && e.response.data && e.response.data.error) || "Failed to save remarks";
                message.error(msg);
                this.setState({ previewPdfRemarkSaving: false });
            });
    }

    renderPreviewPdfModal = () => {
        const { previewPdfModalVisible, previewPdfLoading, previewPdfResult,
            previewPdfSelectedKey, previewPdfSelectedPage } = this.state;

        const STAT = {
            ok:                  { cls: "p", glyph: "✓", text: "OK" },
            mismatch:            { cls: "f", glyph: "✗", text: "Mismatch" },
            not_found_in_pdf:    { cls: "w", glyph: "!",      text: "Not in PDF" },
            backend_unavailable: { cls: "w", glyph: "?",      text: "No backend value" }
        };
        const css = `
        .ppv{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#111827}
        .ppv-head{background:linear-gradient(135deg,#1e40af,#3b82f6);padding:14px 20px;display:flex;align-items:center;justify-content:space-between}
        .ppv-head h2{color:#fff;font-size:14px;font-weight:600;margin:0}
        .ppv-head .e{font-size:11px;color:rgba(255,255,255,.85);margin-top:3px}
        .ppv-cb{width:26px;height:26px;border-radius:6px;border:none;background:rgba(255,255,255,.15);color:#fff;cursor:pointer;font-size:13px}
        .ppv-banner{padding:9px 20px;display:flex;align-items:center;gap:10px;font-size:12px;border-bottom:1px solid #e5e7eb}
        .ppv-banner.ok{background:#ecfdf5;color:#065f46;border-bottom-color:#a7f3d0}
        .ppv-banner.bad{background:#fffbeb;color:#92400e;border-bottom-color:#fcd34d}
        .ppv-pill{margin-left:auto;font-size:10px;font-weight:700;padding:3px 10px;border-radius:12px}
        .ppv-pill.ok{background:#a7f3d0;color:#065f46}.ppv-pill.bad{background:#fde68a;color:#92400e}
        .ppv-chips{display:flex;gap:8px;padding:9px 20px;background:#f9fafb;border-bottom:1px solid #e5e7eb;flex-wrap:wrap}
        .ppv-chip{font-size:11px;color:#6b7280;background:#fff;border:1px solid #e5e7eb;border-radius:6px;padding:3px 10px}
        .ppv-chip b{color:#111827;font-weight:600}
        .ppv-cov{padding:9px 20px;background:#fff;border-bottom:1px solid #e5e7eb;font-size:11px;color:#6b7280}
        .ppv-cov b.r{color:#92400e}.ppv-cov b.y{color:#92400e}.ppv-cov b.g{color:#0d7a54}
        .ppv-body{display:grid;grid-template-columns:38% 62%;min-height:560px}
        .ppv-lp{border-right:1px solid #e5e7eb;background:#fafafa;overflow-y:auto;max-height:600px;padding:12px}
        .ppv-sec{border:1px solid #e5e7eb;border-radius:8px;margin-bottom:8px;overflow:hidden;background:#fff}
        .ppv-sec-h{padding:8px 11px;display:flex;align-items:center;gap:8px;background:#f9fafb;border-bottom:1px solid #eef0f2}
        .ppv-sec-h .t{font-size:12px;font-weight:600;flex:1}
        .ppv-sp{font-size:10px;font-weight:600;padding:2px 8px;border-radius:10px}
        .ppv-sp.p{background:#e8f8f0;color:#0d7a54}.ppv-sp.w{background:#fffbeb;color:#92400e}.ppv-sp.f{background:#fef3c7;color:#92400e}
        .ppv-row{padding:8px 11px;display:flex;flex-wrap:wrap;align-items:flex-start;gap:8px;cursor:pointer;border-top:1px solid #f4f4f5}
        .ppv-remark{flex:0 0 100%;margin-top:6px;padding-left:23px}
        .ppv-saveall{position:sticky;bottom:0;background:#fafafa;padding:10px 2px 2px;margin-top:4px;border-top:1px solid #e5e7eb}
        .ppv-row:hover{background:#f9fafb}
        .ppv-row.active{background:#eff6ff;box-shadow:inset 3px 0 0 #3b82f6}
        .ppv-dot{width:15px;height:15px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px;font-size:8px;font-weight:700;color:#fff}
        .ppv-dot.p{background:#16a571}.ppv-dot.w{background:#f59e0b}.ppv-dot.f{background:#f59e0b}
        .ppv-rl{flex:1;min-width:0}
        .ppv-rl .nm{font-size:12px;font-weight:500;color:#111827}
        .ppv-rl .vl{font-size:10.5px;color:#6b7280;margin-top:2px}
        .ppv-rl .vl .x{color:#b45309;font-weight:600}
        .ppv-rl .vl .g{color:#0d7a54;font-weight:600}
        .ppv-pg{font-size:9.5px;color:#9ca3af;flex-shrink:0;margin-top:2px}
        .ppv-rp{display:flex;flex-direction:column;background:#e8e9eb}
        .ppv-rp .bar{padding:8px 14px;background:#fff;border-bottom:1px solid #e5e7eb;font-size:11px;color:#6b7280;display:flex;align-items:center;gap:8px}
        .ppv-rp iframe{flex:1;width:100%;border:none;background:#e8e9eb}
        .ppv-empty{padding:50px 24px;text-align:center;color:#9ca3af;font-size:12px;line-height:1.6}
        `;

        const close = this.closePreviewPdf;

        let inner = null;
        if (previewPdfLoading) {
            inner = <div style={{ textAlign: "center", padding: "60px" }}><Spin tip="Comparing PDF with backend values..." /></div>;
        } else if (previewPdfResult) {
            const R = previewPdfResult;
            const meta = R.meta || {};
            // Only surface the parameters that did NOT match the backend; matched
            // ones are hidden (their counts still show in the summary line).
            const rows = (R.results || [])
                .map((r, i) => ({ ...r, key: r.key || ("r" + i) }))
                .filter(r => r.status !== "ok");
            const s = R.summary || { ok: 0, mismatch: 0, not_found_in_pdf: 0 };

            // group rows by section, preserving order
            const order = [];
            const groups = {};
            rows.forEach(r => {
                const sec = r.section || "Parameters";
                if (!groups[sec]) { groups[sec] = []; order.push(sec); }
                groups[sec].push(r);
            });
            const secStatus = (list) => list.some(r => r.status === "mismatch") ? "f"
                : list.some(r => r.status === "not_found_in_pdf" || r.status === "backend_unavailable") ? "w" : "p";
            const secLabel = { p: "Clean", w: "Attention", f: "Mismatch" };

            const valNote = (r) => {
                if (r.status === "mismatch")
                    return <span>PDF <span className="x">{r.pdf_value || "—"}</span> ≠ backend <span className="x">{r.backend_value || "—"}</span></span>;
                if (r.status === "ok")
                    return <span><span className="g">{r.backend_value || r.pdf_value}</span> · consistent</span>;
                if (r.status === "not_found_in_pdf")
                    return <span>not found in PDF · backend {r.backend_value || "—"}</span>;
                return <span>no backend value to compare</span>;
            };

            const pdfUrl = R.pdf_url;
            // Prefer the annotated PDF (mismatches boxed in red); fall back to the raw URL.
            const viewerUrl = this.state.previewPdfBlobUrl || pdfUrl;
            const rightPane = !R.applicable ? (
                <div className="ppv-empty">{R.message}</div>
            ) : pdfUrl ? (
                <div className="ppv-rp">
                    <div className="bar">
                        <span>Source: <b>{R.pdf_source}</b></span>
                        <span>· Page <b>{previewPdfSelectedPage}</b></span>
                        {this.state.previewPdfBlobUrl
                            ? <span style={{ color: "#92400e", fontWeight: 600 }}>· mismatches highlighted in yellow</span>
                            : <span style={{ color: "#9ca3af" }}>· loading highlights…</span>}
                        <a href={pdfUrl} target="_blank" rel="noopener noreferrer" style={{ marginLeft: "auto" }}>Open full PDF ↗</a>
                    </div>
                    <iframe
                        key={(this.state.previewPdfBlobUrl ? "a" : "p") + previewPdfSelectedPage}
                        title="kit-pdf"
                        src={viewerUrl + "#page=" + previewPdfSelectedPage + "&toolbar=1&view=FitH"}
                    />
                </div>
            ) : (
                <div className="ppv-empty">{R.message || "No PDF available for this case yet."}</div>
            );

            inner = (
                <div className="ppv">
                    <div className="ppv-head">
                        <div>
                            <h2>PS Kit — Pre-trigger review · {meta.application_no || R.case_id}</h2>
                            <div className="e">{meta.borrower} · {meta.product} · ₹{meta.amount}</div>
                        </div>
                        <button className="ppv-cb" onClick={close}>✕</button>
                    </div>
                    <div className={"ppv-banner " + (R.all_ok ? "ok" : "bad")}>
                        <span>{R.all_ok ? "All parameters match the backend." : R.message + " Click a flagged item to jump to its page in the PDF."}</span>
                        <span className={"ppv-pill " + (R.all_ok ? "ok" : "bad")}>{R.all_ok ? "ALL OK" : "REVIEW NEEDED"}</span>
                    </div>
                    <div className="ppv-chips">
                        <span className="ppv-chip"><b>Case</b> {R.case_id}</span>
                        <span className="ppv-chip"><b>Borrower</b> {meta.borrower || "—"}</span>
                        <span className="ppv-chip"><b>Amount</b> ₹{meta.amount || "—"}</span>
                        <span className="ppv-chip"><b>Bank</b> {meta.bank_code || "—"}</span>
                    </div>
                    <div className="ppv-cov">
                        {s.total || rows.length} parameters checked · <b className="r">{s.mismatch} mismatch</b> · <b className="y">{s.not_found_in_pdf} not in PDF</b> · <b className="g">{s.ok} clean</b>
                    </div>
                    <div className="ppv-body">
                        <div className="ppv-lp">
                            {rows.length === 0 ? (
                                <div style={{ padding: "16px", fontSize: "12px", color: "#0d7a54", background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: "8px" }}>
                                    ✓ All {s.ok} checked parameters match the backend. Nothing to review.
                                </div>
                            ) : order.map(sec => {
                                const list = groups[sec];
                                const st = secStatus(list);
                                return (
                                    <div className="ppv-sec" key={sec}>
                                        <div className="ppv-sec-h">
                                            <span className="t">{sec}</span>
                                            <span className={"ppv-sp " + st}>{secLabel[st]}</span>
                                        </div>
                                        {list.map(r => {
                                            const cfg = STAT[r.status] || STAT.backend_unavailable;
                                            return (
                                                <div
                                                    key={r.key}
                                                    className={"ppv-row" + (previewPdfSelectedKey === r.key ? " active" : "")}
                                                    onClick={() => this.selectPreviewRow(r)}
                                                >
                                                    <span className={"ppv-dot " + cfg.cls}>{cfg.glyph}</span>
                                                    <span className="ppv-rl">
                                                        <span className="nm">{r.parameter}</span>
                                                        <span className="vl">{valNote(r)}</span>
                                                    </span>
                                                    {r.pdf_page ? <span className="ppv-pg">p.{r.pdf_page}</span> : null}
                                                    <div
                                                        className="ppv-remark"
                                                        onClick={(ev) => ev.stopPropagation()}
                                                    >
                                                        <Input.TextArea
                                                            rows={2}
                                                            placeholder="Add a remark / reason for this mismatch…"
                                                            value={this.state.previewPdfRemarks[r.key] || ""}
                                                            onChange={(ev) => this.onPreviewRemarkChange(r.key, ev.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                            {rows.length > 0 ? (
                                <div className="ppv-saveall">
                                    <Button
                                        type="primary"
                                        block
                                        loading={this.state.previewPdfRemarkSaving}
                                        onClick={this.saveAllPreviewRemarks}
                                    >
                                        Save remarks
                                    </Button>
                                </div>
                            ) : null}
                        </div>
                        {rightPane}
                    </div>
                    <style>{css}</style>
                </div>
            );
        }

        return (
            <Modal
                visible={previewPdfModalVisible}
                width={1160}
                style={{ top: 16 }}
                bodyStyle={{ padding: 0 }}
                title={null}
                closable={false}
                footer={null}
                destroyOnClose={true}
                onCancel={close}
            >
                {inner}
            </Modal>
        );
    }

    onTriggerClick = () => {
        // First trigger goes through directly; any later trigger (re-trigger, or trigger
        // again after a delete) must capture a reason.
        const triggeredBefore = this.state.status === "Initiated" || (this.state.logs_data || []).length > 0;
        if (triggeredBefore) {
            this.setState({ retriggerModalVisible: true, retriggerRemarks: "" });
            return;
        }
        this.triggerAgreement();
    }

    closeRetriggerModal = () => {
        this.setState({ retriggerModalVisible: false, retriggerRemarks: "" });
    }

    confirmRetrigger = () => {
        const remarks = (this.state.retriggerRemarks || "").trim();
        if (!remarks) {
            message.error("Please enter a reason for re-triggering");
            return;
        }
        this.triggerAgreement(remarks);
    }

    triggerAgreement = (remarks = "") => {
        var payload = {};
        if(this.props?.caseDetail?.get('business_product_type') == 0 || this.props?.caseDetail?.get('business_product_type') == null) {
            message.error("Please Select Business Product Type");
            return 
        }
        this.props?.caseDetail?.bank_name === "IDFC FIRST Bank" && 
        CaseLeegalityService.triggerFinnOneId(this.props.caseId, this.state.finnOneId).then(()=>{
            message.success("Triggered FinnOne ID")
        })
        if(this.state.doc === 1){
            payload = {
                case_id: this.props.caseId,
                document_id: this.state.doc,
                employeeId:this.state.employeeId,
                remarks: remarks,
                extra_data: {
                    language: this.state.language || "Hindi"
                }
            }
        } else if(this.state.doc === 2){
            payload = {
                case_id: this.props.caseId,
                document_id: this.state.doc,
                employeeId:this.state.employeeId,
                remarks: remarks,
                extra_data: {
                    amount: this.state.adhocAmount
                }
            }
        } else if(this.state.doc === 3){
            payload = {
                case_id: this.props.caseId,
                document_id: this.state.doc,
                employeeId:this.state.employeeId,
                remarks: remarks,
                extra_data: {
                    language: this.state.language,
                    witness_id: this.state.witness
                }
            }
        }
        try {
            this.setState({
                loading : true
            })
            message.loading("Generating template please wait...");
            /* eslint-disable */
            // let hitSignzy = this.props.caseId % 10 == 9 && !this.state.legality_data.document_id && this.props.caseDetail.bank.code == "HHPL";
            let hitSignzy = false;
            CaseLeegalityService.triggerAgreement(payload , hitSignzy).then((response)=> {
                // message.success("Triggered successfully");
                this.setState({
                    templateData: response.data,
                    isVisible: hitSignzy ? true : false,
                    language: "",
                    witeness: "",
                    adhocAmount: "",
                    loading : false,
                    retriggerModalVisible: false,
                    retriggerRemarks: ""
                });
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           })
           .catch(() => {
                this.setState({
                    loading : false
                })
           });
        } catch (e) {
            message.error("Error in generation triggering");
            this.setState({
                loading : false
            })
        }
    }

    retriggerEsign = () => {
        message.loading("Initiating retrigger request please wait...");
        CaseService.retriggerAgreement(this.props.caseId, this.retriggerReason)
            .then(() => {
                message.success("Agreement retriggered successfully. Fetching aggreement data, please wait...");
                this.toggleRetriggerEsign();
                this.getAgreementData();
            })
            .catch(() => {});
    }

    getLogs = () => {
        return (
            <div>
                <div style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    fontSize: "14px",
                    fontWeight: "bold"
                }}>
                    Logs
                </div>
                <Table 
                    style={{border: "1px solid #e8e8e8"}} 
                    columns={AGREEMENT_LOGS_COLS} 
                    dataSource={this.state.logs_data}
                    pagination={false} 
                />
            </div> 
        );
    }

    onChangeDoc = (value) => {
        this.getAgreementData(this.props.caseId, value, 0)
        this.setState({
            doc: value,
            language: "",
            witness: "",
            adhocAmount: ""
        });
    }

    onChangeLanguage = (value) => {
        this.setState({
            language: value
        });
    }

    onChangeWitness = (value) => {
        this.setState({
            witness: value
        });
    }

    amountChange = (value) => {
        this.setState({
            [value.target.name]: value.target.value
        });
    }

    reactivateUrl = () => {
        try {
            message.loading("Reactivating expired url please wait...");
            /* eslint-disable */
           CaseLeegalityService.reinitiateAgreement(this.props.caseId, this.state.doc).then(()=> {
                message.success("Reactivated successfully");
                this.getAgreementData(this.props.caseId, this.state.doc, 0);
           });
        } catch (e) {
            message.error("Error in reactivating url");
        }
    }

    onCopyUrl = (a, record, c) => {
        var input = document.body.appendChild(document.createElement("input"));
        input.value = record.sign_url;
        input.focus();
        input.select();
        document.execCommand('copy');
        input.parentNode.removeChild(input);
        message.success("URL copied");
    }

    TableCellClick = (clickHandler, label) => (columnValue, record) => {
        return (<a onClick={clickHandler.bind(null, columnValue, record)}>{label}</a>);
    }

    TableCellCopyUrl = (clickHandler) => (columnValue, record) => {
        return (
            <span onClick={clickHandler.bind(null, columnValue, record)}>
                <Icon style={{ fontSize: '20px', cursor: "pointer" }} type="copy" />
            </span>
        );
    }

    handleChangeForm=(e, index)=>{
        const value=e.target.value;
        const fieldVal=e.target.name;
        let formFields = [ ...this.state.formFields ];
        formFields[index] = {...formFields[index], [fieldVal]: value};
        this.setState({ formFields });
    }
    triggerButtonDisable=()=>{
        if(this.props.caseDetail.bank_name==="IDFC FIRST Bank" && (this.state.employeeId=="" || this.state.referenceResponse==false || this.state.finnOneId=="")){
            return true
        }
       
        else{
            return false
        }
    }
    cancelReference=()=>{
        this.setState({modalVisible:false})
    }
    titleCase(string){
        return string[0].toUpperCase() + string.slice(1).toLowerCase();
      }
    
    formValidationRules = (el) => {
            if (el === "phone"){   
        return([
            {
                required: true,
                message: "Mobile Number is Required"
            },
            {
                min: 10,
                message: "Enter valid mobile number "
            },
            {
                max: 10,
                message: "Enter valid mobile number "
            },
            {
                pattern: /^(?:\d*)$/,
                message: "Value should contain just number",
            }]
            )} 
            if(el ==="name"){
                return([
                    {
                        max: 30,
                        message: "Max length of name is 30 characters"
                    },
                ])
            }
            if (el ==="pincode"){
                return([
                    {
                        required: true,
                        message: "Field is mandatory"
                    },
                    {
                        //eslint-disable-next-line
                        pattern: "^[1-9][0-9]{5}$",
                        message: "Enter valid Pincode"
                    }]
                )
            }
                else{
                    return(
                        [{ required: true, message: `Please input ${el}!`}]
                    )
                }
    }

    handleEsignDrawer = (refresh) => {
        if(refresh){
            this.getAgreementData(this.props.caseId, this.state.doc, 0);
           
        }
        this.setState({
            isVisible : !this.state.isVisible,
            templateData: {}
        })
    }

    previewDocument = () => {
        this.setState({
            loading: true
        })
        let payload = {}
        if(this.state.doc === 1){
            payload = {
                case_id: this.props.caseId,
                document_id: this.state.doc,
                employeeId:this.state.employeeId,
                remarks: "",
                extra_data: {
                    language: this.state.language || "Hindi"
                }
            }
        }
        const jsonData = encodeURIComponent(JSON.stringify(payload));

        window.open(`/app/preview/document?payload=${jsonData}`, '_blank');

        let hitSignzy = true;
        CaseLeegalityService.triggerAgreement(payload, hitSignzy).then((response) => {
            this.setState({
                templateData: response.data,
                isVisible: hitSignzy ? true : false,
                language: "",
                witeness: "",
                adhocAmount: "",
                loading: false
            });
        }).catch ((e)  => {
            this.setState({
                loading : false
            })
        })
    }
    onchangeManualSigned = (associate) => {
        if (this.state.isManualSigned[associate.id]) {
            message.warning("This case is already manually signed!");
            return;
        }
        const loadingMessage = message.loading("Updating...", 0);
        CaseLeegalityService.changeManualSigned(this.props.caseId, associate?.id).then(res=>{
            if (res.status === 200) {
                loadingMessage();
                this.setState(prevState => ({
                    isManualSigned: {
                        ...prevState.isManualSigned,
                        [associate.id]: true
                    }
                }));
                message.success(res?.data?.detail || "Successfully Signed!");
            }
        }).catch(err => {
            loadingMessage();
            // message.error(err.detail || "Something went wrong!");
            console.error("Error marking as manually signed:", err);
        });
    }

    render() {
        const {  form } = this.props;
        const { getFieldDecorator } = form;

        const { 
            doc, 
            adhocAmount, 
            language, 
            witness, 
            status, 
            last_updated, 
            total_associate,
            witnessList,
            languageList 
        } = this.state;
        var AGREE_COLS = AGREEMENT_APPLICANT_DETAILS_COLS;
        AGREE_COLS = AGREE_COLS.map((col, key) => {
            if(key === "action"){
                return Object.assign({
                    render: this.TableCellClick(this.reactivateUrl, "Reactivate")
                }, col);
            }
            if(key === "copy"){
                return Object.assign({
                    render: this.TableCellCopyUrl(this.onCopyUrl)
                }, col);
            }
            if(key === "is_manual_signed"){
                return Object.assign({
                    render: (_,record) => {
                        return(<Switch checked={this.state.isManualSigned[record.id]}
                             onChange={()=>this.onchangeManualSigned(record)}/>
                    )}
                }, col);
            }
            return col;
        });
        return (
            <div className={"p-10"}>
                <Spin spinning={this.state.loading}>
                {/* <LeegalityTemplateDrawer
                    showTriggerButton={false}
                    isVisible={this.state.isVisible}
                    templateData={this.state.templateData}
                    handleEsignDrawer={this.handleEsignDrawer}
                    caseId = {this.props.caseId}
                /> */}
                {this.state.is_eligible ? <div
                    style={{
                        paddingBottom: "30px",
                        background: "#eceff1",
                    }}
                >
                    <Card
                        style={{
                            padding: "50px",
                            paddingBottom: "30px",
                        }}
                    >
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <div
                                style={{
                                    display: "flex",
                                    flex: 1,
                                    alignContent: "flex-start",
                                    flexDirection: "column",
                                    lineHeight: "14px"
                                }}
                            >
                                <div>
                                    <span 
                                        style={{
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Total Associates : {total_associate ? total_associate : "0"}
                                    </span>
                                </div>
                                <div>
                                    <span
                                        style={{
                                            fontSize: "12px",
                                            fontWeight: "normal",
                                        }}
                                    >
                                        Last Updated at <span style={{color: "#16c79a"}}>{moment(last_updated).format("MMM Do YYYY")}</span>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div
                                    style={{
                                        lineHeight: "14px"
                                    }}
                                >
                                    <span 
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Status: <span>{status} </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div style={{marginTop: "10px"}}>
                        <div className={" mt-5 mr-15 d-flex"} style={{justifyContent: "flex-start"}}>
                                <div>
                                    <Select
                                        style={{ 
                                            width: 200,
                                            marginRight: "20px" 
                                        }}
                                        placeholder="Select"
                                        optionFilterProp="children"
                                        defaultValue={1}
                                        onChange={this.onChangeDoc}
                                        filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        <Option value={1}>PS Kit</Option>
                                        <Option value={2}>Adhoc Kit</Option>
                                        <Option value={3}>Vernacular</Option>
                                    </Select>
                                    {
                                        <Select
                                            getPopupContainer={trigger => trigger.parentNode}
                                            showSearch          
                                            placeholder="Employee name"
                                            style={{ 
                                            width: 200,
                                            marginRight: "10px",
                                        }}
                                            filterOption={(input, option) =>{
                                            return(
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            )
                                            }}
                                                >
                        
                                            { this.state.userLegailityDropdown .map(_ => (
                                                <Option onClick={()=>this.setState({employeeId:_.employee_id})} value={_.employee_id}>{_.name}</Option>
                                                ))}
                                        </Select> 
                                    }
                    
                   
                  
                                </div>
                                {
                                    doc === 1 ?
                                        <Select
                                            style={{ 
                                                width: 200,
                                                marginRight: "20px",
                                            }}
                                            placeholder="Select language"
                                            optionFilterProp="children"
                                            defaultValue={"Hindi"}
                                            onChange={this.onChangeLanguage}
                                            filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {
                                                languageList.map((item, index) => {
                                                    return <Option key={index} value={item}>{item}</Option>
                                                })
                                            }
                                        </Select>
                                        
                                        : null
                                }
                                {doc === 2 ? 
                                    <Input 
                                        placeholder="Adhoc Amount" 
                                        style={{
                                            marginRight: "10px",
                                            width: "200px",
                                        }}
                                        name={"adhocAmount"}
                                        onChange={this.amountChange}
                                    />
                                    : null
                                }
                                {
                                    doc === 3 ? 
                                        <div>
                                            <Select
                                                style={{ 
                                                    width: 200,
                                                    marginRight: "20px",
                                                }}
                                                placeholder="Select language"
                                                optionFilterProp="children"
                                                onChange={this.onChangeLanguage}
                                                filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {
                                                    languageList.map((item, index) => {
                                                        return <Option key={index} value={item}>{item}</Option>
                                                    })
                                                }
                                            </Select>
                                            <Select
                                                style={{ 
                                                    width: 200,
                                                    marginRight: "10px",
                                                }}
                                                placeholder="Select witness"
                                                optionFilterProp="children"
                                                onChange={this.onChangeWitness}
                                                filterOption={(input, option) =>
                                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                {
                                                    witnessList.map((item, index) => {
                                                        return <Option key={index} value={item.id}>{item.name}</Option>
                                                    })
                                                }
                                            </Select>
                                            
                                            
                                        </div>
                                        : null
                                }
                                {this.props?.caseDetail?.bank_name === "IDFC FIRST Bank" && 
                                    <Input placeholder="Finn one Id" maxLength="10" style={{width:"250px"}} onChange={(e) => this.setState({finnOneId:e.target.value})}/>
                            }
                            </div>
                            <div className={"mt-5 mr-15 d-flex"} style={{justifyContent: "flex-start"}}>
                                {this.props.postSanctionPermission && <div>
                                {
                                    doc === 2 && !this.props.recreditViewOnlyPermission ? 
                                        <Button 
                                            type="primary" 
                                            icon="fire"    
                                            style={{ 
                                                background: "#16c79a", 
                                                borderColor: "#16c79a", 
                                                margin: "10px",
                                                marginLeft: "0px" 
                                            }}
                                            disabled={!adhocAmount & doc === 2 || this.triggerButtonDisable() || (!this.state.legality_data.document_id && status === "Initiated")}
                                            onClick={this.onTriggerClick}
                                        >
                                            {status === "Initiated" ? "Re-Trigger" : "Trigger"}
                                        </Button>
                                        : null
                                }
                                {
                                    doc === 3 && !this.props.recreditViewOnlyPermission ? 
                                        <Button 
                                            type="primary" 
                                            icon="fire"     
                                            style={{ 
                                                background: "#16c79a", 
                                                borderColor: "#16c79a", 
                                                margin: "10px",
                                                marginLeft: "0px"
                                            }}
                                            disabled={!(witness && language) || this.triggerButtonDisable() || (!this.state.legality_data.document_id && status === "Initiated")}
                                            onClick={this.onTriggerClick}
                                        >
                                            {status === "Initiated" ? "Re-Trigger" : "Trigger"}
                                        </Button>
                                        : null
                                }
                                {
                                    doc === 1 && !this.props.recreditViewOnlyPermission ? 
                                        <Button 
                                            type="primary" 
                                            icon="fire"  
                                            style={{ 
                                                background: "#16c79a", 
                                                borderColor: "#16c79a", 
                                                margin: "10px",
                                                marginLeft: "0px"
                                            }}
                                            onClick={this.onTriggerClick}
                                            disabled={this.triggerButtonDisable() || (!this.state.legality_data.document_id && status === "Initiated")}
                                        >
                                            {status === "Initiated" ? "Re-Trigger" : "Trigger"}
                                        </Button>
                                        : null
                                }
                                {!this.props.recreditViewOnlyPermission && <Button
                                    onClick={this.openDeleteModal}
                                    type="primary"
                                    icon="delete"
                                    style={{
                                        background: "#16c79a",
                                        borderColor: "#16c79a",
                                        margin: "10px"
                                    }}
                                    disabled={!(this.state.status === "Initiated"  && this.props.permissionContext.get("case_initiate_agreement")) }
                                >
                                    Delete Request
                                </Button> }
                                {!this.props.recreditViewOnlyPermission && <Button
                                    type="primary"
                                    // disabled={true}
                                    icon={"download"}
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    disabled={!this.state.signed_document}
                                >
                                    <a href={this.state.signed_document} target="_blank" download > <span style={{color: "#fff!important", marginLeft: "5px"}}>Download Signed Document</span></a>
                                </Button>}
                                <Button 
                                    type="primary" 
                                    icon="reload" 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    onClick={this.refresh}
                                >
                                    Refresh
                                </Button>
                                {!this.props.recreditViewOnlyPermission && <Button 
                                    type="primary" 
                                    icon="mail" 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    onClick={this.sendEmails}
                                >
                                    Send Email
                                </Button>}
                                {!this.props.recreditViewOnlyPermission && <Button
                                    onClick={this.manuallySigned}
                                    type="primary" 
                                    icon="form" 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }}
                                    // disabled={!(this.state.status === "Initiated"  && this.props.permissionContext.get("case_initiate_agreement")) }
                                >
                                    Marked as Manually Signed
                                </Button> }
                               { this.props.caseDetail?.bank_name==="IDFC FIRST Bank" && !this.props.recreditViewOnlyPermission &&
                               <Button
                                    onClick={() => this.setState({modalVisible:!this.state.modalVisible})}
                                    type="primary" 
                                    icon="form" 
                                    style={{ 
                                        background: "#16c79a", 
                                        borderColor: "#16c79a", 
                                        margin: "10px" 
                                    }
                                }
                                >
                                    Create Reference
                                </Button> 
                                  }
                                    {(this.state.doc == 1 && this.props.caseDetail?.bank?.code == "HHPL") &&
                                        <Button
                                            type="primary"
                                            icon="fire"
                                            style={{
                                                background: "#16c79a",
                                                borderColor: "#16c79a",
                                                margin: "10px",
                                                marginLeft: "0px"
                                            }}
                                            disabled={!adhocAmount & doc === 2 || this.triggerButtonDisable() || (!this.state.legality_data.document_id && status === "Initiated")}
                                            onClick={this.previewDocument}
                                        >
                                            Preview PS KIT
                                        </Button>
                                    }
                                    </div>}
                                {/* Preview pdf is intentionally OUTSIDE the postSanctionPermission gate
                                    so it renders for anyone who can open the Agreement tab. */}
                                <Button
                                    type="primary"
                                    icon="file-pdf"
                                    loading={this.state.previewPdfLoading}
                                    style={{
                                        background: "#16c79a",
                                        borderColor: "#16c79a",
                                        margin: "10px"
                                    }}
                                    onClick={this.previewPdf}
                                >
                                    Preview pdf
                                </Button>
                                <Modal
                                visible={this.state.modalVisible}
                                destroyOnClose={true}
                                closable={true}
                                // onCancel={()=>this.setState({modalVisible:false})}
                                onCancel={this.cancelReference}
                                footer={[
                                <Button key="back" onClick={this.cancelReference} >
                                Cancel
                                </Button>,
                                <Button key="submit" htmlType="submit" disabled={this.props.recreditViewOnlyPermission} onClick={this.createReference}>
                                Submit
                                </Button>
                            ]}
                            >
                                 <Form
      
      autoComplete="off"
    >
        {this.state.formFields.map((formObj,index)=>{
           return( 
                <>
            <span>{`*Reference ${index+1}`}</span>
            {Object.keys(formObj).map((el,idx)=>{
                let objValue = this.state.createReferenceData.length !== 0 && this.state.createReferenceData[index];
                return (
                    <Form.Item
                    label={this.titleCase(el)} name={el}
                >
                    {getFieldDecorator(`${el+(index+1)}`, {
                        initialValue: objValue ? objValue[el] : "",
                            rules: this.formValidationRules(el),
                        })
                    (<Input name={el} onChange={(event) => this.handleChangeForm(event, index)}/>)}
                    </Form.Item>
                )
            })}
            </>
        )})} 
      </Form>
                                </Modal>
                                {this.renderPreviewPdfModal()}
                                <Modal
                                    title="Delete Agreement Request"
                                    visible={this.state.deleteModalVisible}
                                    onOk={this.deleteRequest}
                                    onCancel={this.closeDeleteModal}
                                    okText="Delete"
                                    okButtonProps={{ loading: this.state.deleting, type: "danger" }}
                                    cancelButtonProps={{ disabled: this.state.deleting }}
                                    destroyOnClose
                                >
                                    <p>Please provide a reason for deleting this agreement request.</p>
                                    <Input.TextArea
                                        rows={4}
                                        placeholder="Enter reason for deleting"
                                        value={this.state.deleteRemarks}
                                        onChange={(e) => this.setState({ deleteRemarks: e.target.value })}
                                    />
                                </Modal>
                                <Modal
                                    title="Re-Trigger Agreement Request"
                                    visible={this.state.retriggerModalVisible}
                                    onOk={this.confirmRetrigger}
                                    onCancel={this.closeRetriggerModal}
                                    okText="Re-Trigger"
                                    okButtonProps={{ loading: this.state.loading }}
                                    cancelButtonProps={{ disabled: this.state.loading }}
                                    destroyOnClose
                                >
                                    <p>This agreement has already been triggered before. Please provide a reason for triggering it again.</p>
                                    <Input.TextArea
                                        rows={4}
                                        placeholder="Enter reason for re-triggering"
                                        value={this.state.retriggerRemarks}
                                        onChange={(e) => this.setState({ retriggerRemarks: e.target.value })}
                                    />
                                </Modal>
                            </div>
                        </div>
                    </Card>
                    <div style={{padding: "20px"}}>
                        <Card
                            style={{
                                borderRadius: "5px"
                            }}
                        >
                            <div>
                                <div style={{
                                    marginTop: "20px",
                                    marginBottom: "20px",
                                    fontSize: "14px",
                                    fontWeight: "bold"
                                }}>
                                    Applicant's Details
                                </div>
                                <Table 
                                    style={{border: "1px solid #e8e8e8"}} 
                                    columns={AGREE_COLS} 
                                    dataSource={this.state.agreementApplicantData}
                                    pagination={false} 
                                />
                            </div> 
                            {this.getLogs()}
                        </Card>
                    </div>
                </div>
                :   <div className={"d-flex justify-content-center"}>
                        <Icon className={"mr-5"} type={"exclamation-circle"} style={{ color: "red", fontSize: 18 }} />
                        <h2 style={{
                            textAlign: "center"
                        }}>{this.state.error}</h2>
                    </div>}
                </Spin>
            </div>
        );
    }
}


export default Form.create()(Agreement)
Agreement.propTypes = {
    history: PropTypes.object,
    permissionContext: PropTypes.object,
    caseId: PropTypes.number,
    stageId: PropTypes.number,
    caseDetail: PropTypes.object,
    company: PropTypes.object
};